import dsbridge from 'dsbridge'
import browser from './browser'

export default {
  install: function (Vue, options) {
    Vue.prototype.appLoading = {
      show () {
        dsbridge.call('Hud.showLoading', { text: '加载中' })
      },
      hide () {
        dsbridge.call('Hud.hide', { after: 0 })
      }
    }
    Vue.prototype.openAPPView = function (url, extra, present) {
      dsbridge.call('Navigator.navigate', {
        'route': url,
        'extra': extra,
        'navigateType': present
      })
    }
    Vue.prototype.navigate_pop = function (num) {
      if (browser.versions.tui) {
        return dsbridge.call('Navigator.pop', { route: 'ToPreviousPage', num: num })
      }
    }
    Vue.prototype.navigate_pop1 = function () {
      if (browser.versions.tui) {
        dsbridge.call('Navigator.pop', { route: 'ToRootPage' })
        return true
      }
    }
    Vue.prototype.openLogout = function () {
      localStorage.removeItem('userData')
      if (browser.versions.tui) {
        return dsbridge.call('Operate.logout', '')
      }
      // localStorage.removeItem('userData')
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/dsbridge.js